import { CashflowFacade } from './facade/cashflow.facade';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LatestCashflowFacade } from './facade/latest-cashflow.facade';

@NgModule({
    imports: [
        CommonModule,
    ],
    providers: [
        CashflowFacade,
        LatestCashflowFacade
    ]
})
export class CashflowStoreModule {}
